import { googleMapsId, type GoogleMapsId } from '@letsgethome/types/branded';

/**
 * The SINGLE source of truth for the Google Maps Map ID (style bundle).
 *
 * A PUBLIC, env-invariant constant — it is not a secret and is byte-identical in
 * every environment, so it lives here as a branded code constant rather than in
 * the env/secrets layer (ADR 0142). This collapses the former duplication of the
 * literal across `manifests/env.yaml` (dev default), `app_registry.bzl`
 * (prod/staging projection), and the since-retired `nightly`/`ephemeral`
 * overlay `.bzl` files into one place.
 *
 * Required by Advanced Markers: every marker-bearing `<Map>` passes this as
 * `mapId`, and the `GoogleMapsId` brand means only this validated constant can
 * be supplied — an empty/raw string is a compile error, so a map that silently
 * drops its pin is unrepresentable.
 */
export const GOOGLE_MAPS_MAP_ID: GoogleMapsId = googleMapsId('82adb2908a28f329');
